import {
  GET_GOOD_SERVICES_HEAD_MASTER_LIST_SUCCESS,
  GET_GOOD_SERVICES_HEAD_MASTER_LIST_FAIL,
  GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_SUCCESS,
  GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_FAIL,
  ADD_NEW_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  ADD_NEW_GOOD_SERVICES_HEAD_MASTER_FAIL,
  UPDATE_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  UPDATE_GOOD_SERVICES_HEAD_MASTER_FAIL,
  DELETE_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  DELETE_GOOD_SERVICES_HEAD_MASTER_FAIL,
} from "./actionTypes"

const INIT_STATE = {
  goodServicesHead: [],
  addGoodServicesHead: [],
  goodServicesHeadDetail: {},
  error: {},
  loading: true,
}

const goodServicesHeadMaster = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GOOD_SERVICES_HEAD_MASTER_LIST_SUCCESS:
      return {
        ...state,
        goodServicesHead: action.payload,
        loading: false,
      }

    case GET_GOOD_SERVICES_HEAD_MASTER_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_SUCCESS:
      return {
        ...state,
        goodServicesHeadDetail: action.payload,
        loading: false,
      }

    case GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case ADD_NEW_GOOD_SERVICES_HEAD_MASTER_SUCCESS:
      return {
        ...state,
        addGoodServicesHead: [...state.addGoodServicesHead, action.payload],
      }

    case ADD_NEW_GOOD_SERVICES_HEAD_MASTER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case UPDATE_GOOD_SERVICES_HEAD_MASTER_SUCCESS:
      return {
        ...state,
        addGoodServicesHead: state.addGoodServicesHead.map(goodServicesHead =>
          goodServicesHead.id === action.payload.id ? { ...goodServicesHead, ...action.payload } : goodServicesHead
        ),
      }

    case UPDATE_GOOD_SERVICES_HEAD_MASTER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_GOOD_SERVICES_HEAD_MASTER_SUCCESS:
      return {
        ...state,
        goodServicesHead: state.goodServicesHead.data.filter(
          goodServicesHead => goodServicesHead.id.toString() !== action.payload.toString()
        ),
      }

    case DELETE_GOOD_SERVICES_HEAD_MASTER_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default goodServicesHeadMaster
